<template>
  <div>
    <h1>{{ seccion }}</h1>
    <p></p>
  <div class="d-flex flex-row">
    <articulo
      v-for="item in articulos"
      :key="item.Id"
      v-bind:articulo="item"
      v-bind:src_carro="src_carro"
      v-bind:src_lupa="src_lupa"
    />
  </div>
  </div>

</template>
<script>
import Servicios from "../services.js";
import Articulo from "./Articulo.vue";

export default {
  components: { Articulo },
  data() {
    return {
      src_carro: "dist/img/icon-carro.png",
      src_lupa: "dist/img/icon-lupa.png",
      articulos: [],
      seccion: ''
    };
  },
  watch: {
    $route(to, from) {
      console.log("to", to, "from", from);
      if (to.name == "section") {
        console.log("to", to, "from", from);
        const idSeccion = to.params.id;
        console.log("idSeccion", idSeccion);        
        this.obtenerArticulos(idSeccion);
      }
    },
  },
  
  async created() {
    const idSeccion = this.$route.params.id;
    console.log("idSeccion", idSeccion);
    await this.obtenerArticulos(idSeccion);
  },

  methods: {
    async obtenerArticulos(idSeccion) {
      var vm = this;
      let articulos = await Servicios.ObtenerArticulosSeccion(idSeccion);      
      vm.articulos = articulos;
      const titulo = this.$store.getters.getTituloSeccion(idSeccion);
      console.log("Titulo", titulo);
      vm.seccion = titulo;
       console.log("Articulos",vm.articulos);
    },
  },
};
</script>
